const teacher = [
  // 问答列表（老师）
  {
    path: '/TeaQuestionAnswers',
    name: 'TeaQuestionAnswers',
    component: () =>
      import('../views/tea/teaQuestionAnswers/List.vue'),
    meta: {
      title: '问答列表',
    }
  },
  /** 
  * 讲师登录设置
  * */
  {
    path: '/TeaLogin',
    name: 'TeaLogin',
    component: () =>
      import('../views/tea/login/TeaLogin.vue'),
    meta: {
      title: '讲师登录'
    }
  },
  {
    path: '/TeaSmsLogin',
    name: 'TeaSmsLogin',
    component: () =>
      import('../views/tea/login/TeaSmsLogin.vue'),
    meta: {
      title: '验证码登录'
    }
  },
  {
    path: '/Tea-forget-pass',
    name: 'TeaForgetPass',
    component: () =>
      import('../views/tea/login/TeaForgetPass.vue'),
    meta: {
      title: '忘记密码'
    }
  },
  {
    path: '/Tea-bind-mobile',
    name: 'TeaBindMobile',
    component: () =>
      import('../views/tea/login/TeaBindMobile.vue'),
    meta: {
      title: '绑定手机号'
    }
  },
  {
    path: '/Tea-set-pass',
    name: 'TeaSetPass',
    component: () =>
      import('../views/tea/login/TeaSetPass.vue'),
    meta: {
      title: '设置密码'
    }
  },
  {
    path: '/TeaHomePage',
    name: 'TeaHomePage',
    component: () =>
      import('../views/tea/TeaHomePage.vue'),
    meta: {
      title: '讲师首页'
    }
  },
  {
    path: '/TeaOptions',
    name: 'TeaOptions',
    component: () =>
      import('../views/tea/Options.vue'),
    meta: {
      title: '讲师设置'
    }
  },
  {
    path: '/TeaQuesDetail',
    name: 'TeaQuesDetail',
    component: () =>
      import('../views/tea/teaQuestionAnswers/Que_detail.vue'),
    meta: {
      title: '问答详情'
    }
  },
  {
    path: '/TeaResponse',
    name: 'TeaResponse',
    component: () =>
      import('../views/tea/teaQuestionAnswers/Response.vue'),
    meta: {
      title: '我来回答'
    }
  },
  {
    path: '/TeaMyResponse',
    name: 'TeaMyResponse',
    component: () =>
      import('../views/tea/teaQuestionAnswers/MyResponse.vue'),
    meta: {
      title: '我的回答'
    }
  },
  {
    path: '/TeaQuestionDetail',
    name: 'TeaQuestionDetail',
    component: () =>
      import('../views/tea/teaQuestionAnswers/QuestionDetail.vue'),
    meta: {
      title: '题目回答'
    }
  },
  {
    path: '/TeaMyAccount',
    name: 'TeaMyAccount',
    component: () =>
      import('../views/tea/account/MyAccount.vue'),
    meta: {
      title: '账户余额'
    },
  },
  {
    path: '/TeaCommonProblemt',
    name: 'TeaCommonProblem',
    component: () =>
      import('../views/tea/account/CommonProblem.vue'),
    meta: {
      title: '常见问题'
    },
  },
  {
    path: '/TeaWithdraw',
    name: 'TeaWithdraw',
    component: () =>
      import('../views/tea/account/Withdraw.vue'),
    meta: {
      title: '提现'
    },
  },
  {
    path: '/TeaAccoutList',
    name: 'TeaAccoutList',
    component: () =>
      import('../views/tea/account/AccoutList.vue'),
    meta: {
      title: '账户管理'
    },
  },
  {
    path: '/TeaAddAccount',
    name: 'TeaAddAccount',
    component: () =>
      import('../views/tea/account/AddAccount.vue'),
    meta: {
      title: '添加账号'
    }
  },
  {
    path: '/TeaTransferDetail',
    name: 'TeaTransferDetail',
    component: () =>
      import('../views/tea/account/TransferDetail.vue'),
    meta: {
      title: '提现详情'
    }
  }
]

export default teacher